import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useLibraryStore = create(
  persist(
    (set, get) => ({
      items: [],
      // readingProgress: { [contentId]: { chapterId, chapterNum, source, updatedAt } }
      readingProgress: {},
      // readHistory: [{ mangaId, mangaTitle, chapterId, chapterNum, source, readAt }]
      readHistory: [],

      setItems: (items) => set({ items }),

      upsertItem: (item) => set(state => {
        const existing = state.items.findIndex(i => i.content_id === item.content_id)
        if (existing >= 0) {
          const updated = [...state.items]
          updated[existing] = { ...updated[existing], ...item }
          return { items: updated }
        }
        return { items: [item, ...state.items] }
      }),

      removeItem: (contentId) => set(state => ({
        items: state.items.filter(i => i.content_id !== contentId)
      })),

      getItem: (contentId) => get().items.find(i => i.content_id === contentId),

      setReadingProgress: (contentId, data) => set(state => ({
        readingProgress: {
          ...state.readingProgress,
          [contentId]: { ...data, updatedAt: Date.now() }
        }
      })),

      getReadingProgress: (contentId) => get().readingProgress[contentId],

      addToHistory: (entry) => set(state => {
        // Remove duplicate for same chapter, prepend, cap at 300
        const filtered = state.readHistory.filter(h => h.chapterId !== entry.chapterId)
        return { readHistory: [{ ...entry, readAt: Date.now() }, ...filtered].slice(0, 300) }
      }),
    }),
    { name: 'nakama-library' }
  )
)
